<template>
  <div class="docDetails" v-loading="loading">
    <div class="detail_msg">
      <div @click="back" class="bc_butn">返回</div>
      <span>填写文件信息</span>
    </div>
    <div class="mySeal">
      <div class="describe_test">
        电子签名
        <span>不适用以下文书</span>:
        <br />1、涉及婚姻、继承、收养等人身关系的; 2、涉及停止供水、供热、供气等公用事业服务的; 3、法律、行政法规规定的不适用电子文书的其他形式。
      </div>
      <el-form :model="new_contact" label-width="150px" class="from_list" :rules="rules" ref="new_contact" size="small">
        <el-form-item label="文件名称" prop="originalFilename">
          <el-input style="width: 65%" v-model="new_contact.originalFilename" placeholder="请输入您的文件名称" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="签署截止日期" prop="date">
          <div style="width: 24%;height: 30px;line-height: 30px;float: left">
            <span class="na_test">自</span>
            <span class="na_data">{{createDate | timeFormat("yyyy-mm-dd")}}</span>
            <span class="na_test_1">截止到</span>
          </div>

          <el-date-picker
            id="haofan_s"
            class="el-date-picker_pick"
            v-model="new_contact.date"
            format="yyyy-MM-dd"
            @click="haofan"
            type="date"
            :picker-options="pickerOptions"
            placeholder="选择日期"
          ></el-date-picker>
          <el-button icon="el-icon-date" @click="haofan" class="buyyon_icon"></el-button>
        </el-form-item>
        <el-form-item label="备注">
          <el-input style="width: 65%" type="textarea" v-model="new_contact.remark" :rows="4" placeholder="请输入您的备注" maxlength="400"></el-input>
          <!--                    <br>-->
          <!--                    <span style="margin-left: 60%">上传附件</span>-->
        </el-form-item>
        <el-form-item label="签署代表" prop="serial" v-if="behalfEnterprises.length>0">
          <el-radio-group v-model="new_contact.representType" @change="enterprises()">
            <el-radio label="1" border class="el_radio el_radio_one">
              <div>代表企业签署</div>
            </el-radio>
            <el-radio label="2" border class="el_radio el_radio_one">
              <div>代表个人签署</div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="代表企业名称" prop="serial" v-if="new_contact.representType == 1 && behalfEnterprises.length>0">
          <el-select class="guang_b" v-model="new_contact.representIndex" value-key="authorizeCompanyId" placeholder="请选择" @change="changeSelect">
            <el-option v-for="item in behalfEnterprises" :key="item.authorizeCompanyId" :label="item.authorizeCompanyName" :value="item.authorizeCompanyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择签署属性" prop="serial">
          <el-radio-group v-model="new_contact.serial" @change="getserial()">
            <el-radio label="1" border class="el_radio">
              <div>签署文件</div>
              <div class="fu_test">发起合同，自己也签署</div>
            </el-radio>
            <el-radio label="2" border class="el_radio" :disabled="new_contact.representType == 1">
              <div>发起合同</div>
              <div class="fu_test">发起合同，自己不签署</div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="签署顺序" prop="signRule">
          <el-radio-group v-model="new_contact.signRule">
            <el-radio label="1" border class="el_radio">
              <div>无序签署</div>
              <div class="fu_test">签署顺序不受限制</div>
            </el-radio>
            <el-radio label="2" border class="el_radio">
              <div>顺序签署</div>
              <div class="fu_test">根据设置的签署方按序签署</div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="签署方">
          <el-button style="width: 248px;margin-right: 15px;" @click="addDomain(0)" type="primary" icon="el-icon-user">
            添加个人用户
            <i class="el-icon-plus el-icon--right"></i>
          </el-button>
          <el-button style="width: 248px" @click="addDomain(1)" type="primary" icon="el-icon-document-copy">
            添加企业用户
            <i class="el-icon-plus el-icon--right"></i>
          </el-button>
        </el-form-item>
        <el-form :model="currentItemOne" ref="currentItemOne" label-width="150px" size="small">
          <el-form-item
            v-for="(domain, index) in currentItemOne.domains"
            :label="domain.title"
            :key="index"
            :prop="'domains.' + index + '.value'"
            :rules="{
                      required: true, message: ' ', trigger: 'blur'
                    }"
          >
            <el-input
              :disabled="domain.title == '自己'"
              v-model="domain.value"
              :placeholder="domain.test"
              @blur="getsignatory(index)"
              @input="changeInputValue(domain)"
              class="el_input_o"
            ></el-input>
            <el-button :disabled="domain.title == '自己'" icon="iconfont icon-bianzu1" @click="Address_book(index)" class="el-button_icon"></el-button>
            <el-input :disabled="domain.title == '自己'" type="text" v-model="domain.remarkName" placeholder="请输入用户备注" class="el_input"></el-input>
            <el-button :disabled="domain.title == '自己'" @click.prevent="removeDomain(domain)" style="margin: 0 15px;color: #FFA03F;border:1px solid #FFA03F">删除</el-button>
            <span :class="domain.activation==1?'Safety':'Danger'" v-if="domain.activation_one !=3">
              {{activation[domain.activation]
              }}
            </span>
            <span v-if="domain.activation_one !=3" :class="domain.authenStatus==1?'Safety':'Danger'">{{authenStatus[domain.authenStatus]}}</span>
            <span class="Danger" v-if="domain.activation_one ==3">该用户未注册</span>
          </el-form-item>
        </el-form>
      </el-form>
      <div class="from_div">
        <el-button :disabled="disabled" class="from_button" type="primary" @click="nextDoc()">下一步</el-button>
        <el-button :disabled="disabled" class="from_button from_button_one" type="primary" @click="getDoc(1,3)">存为草稿</el-button>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="选择通讯录人员" :visible.sync="del_seal_dialog" width="617" center>
      <el-table :data="options" header-row-class-name="contacts-header" style="width: 100%;" row-class-name="contact" class="contact_tb" height="400px" stripe>
        <template slot="empty">
          <img src="@/assets/img/nullDate.png" style="width: 285px;height: 145px; margin-left: -67px;" />
          <p style="color:rgba(49,202,132,1);font-size: 18px;margin: 0">暂无数据</p>
        </template>
        <el-table-column prop="userName" align="center" label="账户名" :show-overflow-tooltip="true" header-align="center">
          <template slot-scope="scope">{{scope.row.userName||scope.row.userAccount}}</template>
        </el-table-column>
        <el-table-column prop="remarkName" align="center" label="备注名称" :show-overflow-tooltip="true" header-align="center"></el-table-column>
        <el-table-column prop="userAccount" align="center" label="账号" :show-overflow-tooltip="true" header-align="center"></el-table-column>
        <el-table-column label="账号类型" align="center">
          <template slot-scope="scope">{{ scope.row.userType==0?'个人账号':'企业账号'}}</template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="presentContact(scope.row);del_seal_dialog=false" type="text">确认</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="hide_pagination"
        background
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="prev, pager, next,sizes,jumper"
        :total="pages_total"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="del_seal_dialog=false" plain>取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'local_file',
  data() {
    return {
      activation: {
        0: '未激活',
        1: '已激活'
      },
      authenStatus: {
        0: '未认证',
        1: '已认证'
      },
      new_contact: {
        presentUserType: '1',
        serial: '1',
        signRule: '2',
        remark: '',
        representType: '2',
        originalFilename: '',
        date: new Date(),
        representIndex: ''
      },
      currentItemOne: {
        domains: []
      },
      loading: false,
      disabled: true,
      getData: {},
      createDate: '',
      rules: {
        originalFilename: [{ required: true, message: '请输入文件名称', trigger: 'blur' }],
        date: [{ required: true, message: '时间不能为空', trigger: 'blur' }],
        serial: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
        signRule: [{ required: true, message: '类型不能为空', trigger: 'blur' }]
      },
      pickerOptions: {
        disabledDate(time) {
          var lstDate = new Date('2038-01-18')
          return time.getTime() < Date.now() - 8.64e7 || time > lstDate.getTime(lstDate)
        }
      },
      options: [],
      signatoryDate: {},
      pageSize: 5,
      pageNum: 1,
      pages_total: 0,
      hide_pagination: false,
      del_seal_dialog: false,
      present_contact: {},
      ddate: {},
      behalfEnterprises: [],
      mesla: null
    }
  },
  created() {
    this.createDate = new Date()
    this.contractId = this.$route.params.id || this.$SIF.getLocalStorage('contractId')
    // this.new_contact.originalFilename =  unescape(this.$route.params.test)
    this.new_contact.originalFilename = this.$route.params.test
    this.get_contract()
    if (this.new_contact.serial == '1') {
      this.getserial()
    }
    if (this.$SIF.getLocalStorage('userInfo').userType == 0) {
      this.get_auth()
    }
    this.getMeals()
  },
  methods: {
    // 获取是否有套餐
    getMeals() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.meal + '/centreBalanceController/getUserId',
        succFun: res => {
          this.mesla = res.data
        },
        failFun: res => {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    haofan() {
      document.getElementById('haofan_s').focus()
    },
    // 获取个人用户是否被企业授权
    //
    get_auth() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.auth + '/authorize/getAuthAvailableCompany',
        succFun: res => {
          this.behalfEnterprises = res.data
        }
      })
    },
    // 个人用户代表签署方切换
    enterprises() {
      if (this.new_contact.representType == '1') {
        this.new_contact.serial = '1'
      }
    },
    // 监听input输入
    changeInputValue(i) {
      if (!i.value) {
        this.disabled = true
      }
      if (i.userType == 0) {
        let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!reg.test(i.value)) {
          this.disabled = true
          return false
        }
        this.disabled = false
      } else if (i.userType == 1) {
        let reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        let num = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/
        if (!reg.test(i.value) && !num.test(i.value)) {
          this.disabled = true
          return false
        }
        this.disabled = false
      }
    },
    // 草稿查询签署方
    get_contract() {
      if (this.$route.params.id == 1) {
        this.contractId = this.$SIF.getLocalStorage('contractId')
      }
      if (this.contractId == 1) {
        return
      }
      this.$SIF.httpPost({
        url: this.$SIF._serve.manage + '/query/list/group/contract-join-user',
        data: {
          contractId: this.contractId
        },
        succFun: res => {
          this.ddate = res.data.me
          if (res.data.others.length > 0) {
            this.currentItemOne.domains = res.data.others

            for (var i = 0; i < res.data.others.length; i++) {
              this.currentItemOne.domains[i].value = res.data.others[i].userAccount
              this.currentItemOne.domains[i].remarkName = res.data.others[i].userName
              this.currentItemOne.domains[i].activation = res.data.others[i].activation
              this.currentItemOne.domains[i].authenStatus = res.data.others[i].authenStatus

              if (res.data.others[i].userAccount == this.$SIF.getLocalStorage('userInfo').loginAccount) {
                this.currentItemOne.domains[i].title = '自己'
              } else {
                if (res.data.others[i].userType == '0') {
                  this.currentItemOne.domains[i].title = '个人'
                } else {
                  this.currentItemOne.domains[i].title = '企业'
                }
              }
            }
            this.currentItemOne.domains = JSON.parse(JSON.stringify(this.currentItemOne.domains))
          }
        }
      })
      this.$SIF.httpPost({
        url: this.$SIF._serve.contract + '/query/contract',
        data: {
          contractId: this.contractId
        },
        succFun: res => {
          this.new_contact.contractId = res.data.contractId
          this.new_contact.remark = res.data.remark
          this.new_contact.originalFilename = res.data.contractName
          this.new_contact.date = new Date(Date.parse(res.data.signEndDate.replace(/-/g, '/')))
          if (res.data.signRule == 'serial') {
            this.new_contact.signRule = '2'
          } else {
            this.new_contact.signRule = '1'
          }
          if (res.data.signPattern == 'issueAndSign') {
            this.new_contact.serial = '1'
          } else {
            this.new_contact.serial = '2'
          }
          if (res.data.representType == 'company') {
            this.new_contact.representType = '1'
          } else {
            this.new_contact.representType = '2'
          }
          this.new_contact.representIndex = res.data.representIndex
        }
      })
    },
    //获取通讯录人员
    Address_book(i) {
      this.get_contacts()
      this.present_contact = this.currentItemOne.domains[i]
      this.is = i
      this.del_seal_dialog = true
    },
    presentContact(i) {
      this.present_contact.value = i.userAccount
      this.present_contact.remarkName = i.remarkName
      this.present_contact.userType = i.userType
      if (i.userType == 1) {
        this.present_contact.title = '企业'
      } else {
        this.present_contact.title = '个人'
      }
      this.getsignatory(this.is, 3)
    },
    addDomain(i) {
      this.disabled = true
      if (this.currentItemOne.domains.length > 9) {
        this.$message({
          message: '签署方最多10人,请删除之后再添加',
          type: 'warning'
        })
        return
      }
      this.currentItemOne.domains.push({
        value: '',
        userName: '',
        remarkName: '',
        key: Date.now(),
        userType: i,
        test: i == 0 ? '请输入个人用户账号' : '请输入企业账号',
        title: i == 0 ? '个人' : '企业',
        activation: '',
        authenStatus: '',
        activation_one: ''
      })
    },
    // 查询签署方信息
    getsignatory(i, ass) {
      var dt = this.currentItemOne.domains[i]
      if (!dt.value) {
        return
      }
      if (dt.userType == 0) {
        let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!reg.test(dt.value)) {
          this.$message({
            message: '手机号格式不正确，请重新输入',
            type: 'warning'
          })
          // dt.value =''
          // dt.remarkName =''
          return false
        }
      } else if (dt.userType == 1) {
        let reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        let num = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/
        if (!reg.test(dt.value) && !num.test(dt.value)) {
          this.$message({
            message: '企业账号格式不正确，请重新输入',
            type: 'warning'
          })
          // dt.remarkName =''
          // dt.value =''
          return false
        }
      }
      for (var it = 0; it < this.currentItemOne.domains.length; it++) {
        if (it != i) {
          if (this.currentItemOne.domains[it].value == dt.value) {
            this.$message({
              message: '用户不能重复添加',
              type: 'warning'
            })
            dt.value = ''
            dt.remarkName = ''
            return
          }
        }
      }
      if (this.new_contact.serial == 2 && dt.value == this.$SIF.getLocalStorage('userInfo').loginAccount) {
        this.$message({
          message: '发起文件模式不能添加自己,请修改',
          type: 'warning'
        })
        dt.value = ''
        return
      }
      this.$SIF.httpPost({
        url: this.$SIF._serve.usermanage + '/contacts/query/signatory',
        data: {
          queryValue: this.currentItemOne.domains[i].value
        },
        succFun: res => {
          if (res.data) {
            dt.userAccount = res.data.userAccount
            dt.activation = res.data.activation
            dt.authenStatus = res.data.authenStatus
            dt.userId = res.data.id
            dt.userType = res.data.userType
            dt.activation_one = 1
            if (ass == 3) {
              dt.remarkName = res.data.userName ? res.data.userName : this.present_contact.remarkName
            } else {
              dt.remarkName = res.data.userName
            }
            // this.currentItemOne.domains[i] = dt
            this.$set(this.currentItemOne.domains, i, dt)
            this.$SIF.httpPost({
              url: this.$SIF._serve.usermanage + '/contacts/add/signatory',
              data: {
                addValue: dt.value
              },
              succFun: res => {},
              failFun: res => {}
            })
            var domeDate = []
            for (var i = 0; i < this.currentItemOne.domains.length; i++) {
              if (!this.currentItemOne.domains[i].value) {
                domeDate.push(this.currentItemOne.domains[i])
              }
            }
            if (domeDate.length > 0) {
              this.disabled = true
            } else {
              this.disabled = false
            }
          } else {
            dt.userAccount = dt.value
            dt.activation_one = 3
            this.$confirm('此用户为未注册用户,是否确认添加', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.$SIF.httpPost({
                  url: this.$SIF._serve.usermanage + '/contacts/add/signatory',
                  data: {
                    addValue: dt.value
                  },
                  succFun: res => {
                    dt.userAccount = res.data.userAccount
                    dt.activation = res.data.activation
                    dt.authenStatus = res.data.authenStatus
                    dt.userId = res.data.id
                    dt.userType = res.data.userType
                    dt.remarkName = res.data.userName
                    dt.activation_one = 1
                    this.$set(this.currentItemOne.domains, i, dt)
                    var domeDate = []
                    for (var i = 0; i < this.currentItemOne.domains.length; i++) {
                      if (!this.currentItemOne.domains[i].value) {
                        domeDate.push(this.currentItemOne.domains[i])
                      }
                    }
                    if (domeDate.length > 0) {
                      this.disabled = true
                    } else {
                      this.disabled = false
                    }
                  },
                  failFun: res => {
                    this.$confirm('社会信用代码不存在.此用户无法添加', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    })
                      .then(() => {
                        dt.value = ''
                        dt.userAccount = ''
                        dt.activation = 0
                        dt.authenStatus = 0
                        dt.userId = ''
                        dt.userType = ''
                        dt.remarkName = ''
                        ;(dt.test = dt.userType == 0 ? '请输入个人用户账号' : '请输入企业账号'), (dt.title = dt.userType == 0 ? '个人' : '企业')
                      })
                      .catch(() => {
                        dt.userAccount = ''
                        dt.activation = 0
                        dt.authenStatus = 0
                        dt.userId = ''
                        dt.userType = ''
                        dt.remarkName = ''
                        ;(dt.value = ''),
                          (dt.test = dt.userType == 0 ? '请输入个人用户账号' : '请输入企业账号'),
                          (dt.title = dt.userType == 0 ? '个人' : '企业')
                      })
                  }
                })
              })
              .catch(() => {
                dt.userAccount = ''
                dt.activation = 0
                dt.authenStatus = 0
                dt.userId = ''
                dt.userType = ''
                dt.remarkName = ''
                dt.value = ''
                ;(dt.test = dt.userType == 0 ? '请输入个人用户账号' : '请输入企业账号'), (dt.title = dt.userType == 0 ? '个人' : '企业')
              })
          }
        }
      })
    },
    removeDomain(item) {
      var index = this.currentItemOne.domains.indexOf(item)
      if (index !== -1) {
        this.currentItemOne.domains.splice(index, 1)
        var domeDate = []
        for (var i = 0; i < this.currentItemOne.domains.length; i++) {
          if (!this.currentItemOne.domains[i].value) {
            domeDate.push(this.currentItemOne.domains[i])
          }
        }
        if (domeDate.length > 0) {
          this.disabled = true
        } else {
          this.disabled = false
        }
      }
    },
    back() {
      this.$router.go(-1) //返回上一层
    },
    changeSelect(data) {
      for (var i = 0; i < this.behalfEnterprises.length; i++) {
        if (this.behalfEnterprises[i].authorizeCompanyId == data && this.behalfEnterprises[i].packageExists == false) {
          this.$message({
            message: '您代表的企业名下无可用套餐,无法发起签署',
            type: 'warning'
          })
          this.new_contact.representIndex = ''
          return
        }
      }
    },
    // 获取人员信息
    get_contacts() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.usermanage + '/contacts/queryPage',
        data: {
          entity: {},
          pageBean: {
            pageSize: this.pageSize,
            pageNum: this.pageNum
          }
        },
        succFun: res => {
          var dt = res.data.list
          this.options = dt
          this.pages_total = res.data.total
        }
      })
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.get_contacts()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.get_contacts()
    },
    // 新增合同草稿箱
    getDoc(i, dd) {
      if (!this.new_contact.originalFilename) {
        this.$message({
          message: '文件名称不能为空',
          type: 'warning'
        })
        return
      }
      if (!this.new_contact.date) {
        this.$message({
          message: '时间不能为空',
          type: 'warning'
        })
        return
      }
      if (this.new_contact.date) {
        var date = this.$options.filters.timeFormat(this.new_contact.date, 'yyyy-mm-dd') + ' 23:59:59'
        var oDate1 = new Date(Date.parse(date.replace(/-/g, '/')))
        var oDate2 = new Date()
        if (oDate1.getTime() < oDate2.getTime()) {
          this.$message({
            message: '截止日期需大于当前日期',
            type: 'warning'
          })
          return
        }
      }

      if (this.currentItemOne.domains.length == 0) {
        this.$message({
          message: '签署方不能为空',
          type: 'warning'
        })
        return
      }
      for (var a = 0; a < this.currentItemOne.domains.length; a++) {
        if (!this.currentItemOne.domains[a].userId) {
          this.$confirm('存在未填写信息的签署人.是否删除未填写信息签署方', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.removeDomain(this.currentItemOne.domains[a])
          })
          return
        }
      }
      debugger
      if (this.$SIF.getLocalStorage('contractId') && this.$SIF.getLocalStorage('contractId') != 1) {
        this.Modify_contract(this.new_contact, dd)
        return
      }
      if (this.$route.params.type == 2) {
        this.Modify_contract(this.ddate, dd)
        return
      }
      if (this.new_contact.signRule == 1) {
        this.signRule = 'parallel'
      } else {
        this.signRule = 'serial'
      }
      if (this.new_contact.serial == 1) {
        this.signPattern = 'issueAndSign'
      } else {
        this.signPattern = 'justIsuue'
      }
      if (this.new_contact.representType == 1) {
        this.representType = 'company'
        this.representIndex = this.new_contact.representIndex
      } else {
        this.representType = 'own'
        this.representIndex = ''
      }
      if (this.new_contact.representType == 1 && this.$SIF.getLocalStorage('userInfo').userType == 0) {
        if (!this.new_contact.representIndex) {
          this.$message({
            message: '代表企业不能为空',
            type: 'warning'
          })
          return
        }
      }

      this.loading = true
      this.$SIF.httpPost({
        url: this.$SIF._serve.manage + '/contract/add',
        data: {
          pdfFileSaveId: this.$route.params.pdfFileSaveId,
          contractName: this.new_contact.originalFilename,
          remark: this.new_contact.remark,
          signRule: this.signRule,
          signPattern: this.signPattern,
          signEndDate: this.$options.filters.timeFormat(this.new_contact.date, 'yyyy-mm-dd') + ' 23:59:59',
          representType: this.representType,
          representIndex: this.representIndex,
          contractType: ''
        },
        succFun: res => {
          if (res.code == 10000) {
            if (i == 2) {
              this.Modify_contract(res.data)
              return
            }
            // this.loading =false
            // this.$message({
            //     message: '已存至草稿箱',
            //     type: 'success'
            // });
            // this.new_contact = {};
            // this.back()

            this.delcontract(res.data.contractId, 'draft')
          } else {
            this.loading = false
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        },
        failFun: res => {
          this.loading = false
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    nextDoc() {
      if (!this.mesla && this.new_contact.representType === '2') {
        this.$confirm('套餐余额不足，请重新购买套餐', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({ name: 'buyMeal' })
        })
        return
      }
      this.getDoc(2)
    },
    // 更新合同
    Modify_contract(i, dd) {
      debugger
      if (this.new_contact.signRule == 1) {
        i.signRule = 'parallel'
      } else {
        i.signRule = 'serial'
      }
      if (this.new_contact.serial == 1) {
        i.signPattern = 'issueAndSign'
      } else {
        i.signPattern = 'justIsuue'
      }
      if (this.new_contact.representType == 1) {
        this.representType = 'company'
        this.representIndex = this.new_contact.representIndex
      } else {
        this.representType = 'own'
        this.representIndex = ''
      }
      if (this.new_contact.representType == 1 && this.$SIF.getLocalStorage('userInfo').userType == 0) {
        if (!this.new_contact.representIndex) {
          this.$message({
            message: '代表企业不能为空',
            type: 'warning'
          })
          return
        }
      }

      this.$SIF.httpPost({
        url: this.$SIF._serve.contract + '/update/contract',
        data: {
          ...i,
          remark: this.new_contact.remark,
          contractName: this.new_contact.originalFilename,
          representType: this.representType,
          representIndex: this.representIndex,
          signEndDate: this.$options.filters.timeFormat(this.new_contact.date, 'yyyy-mm-dd') + ' 23:59:59'
        },
        succFun: res => {
          if (res.code == 10000) {
            if (dd == 3) {
              this.$message({
                message: '已存至草稿箱',
                type: 'success'
              })
              this.loading = false
              this.back()
              return
            }
            this.delcontract(i.contractId)
          } else {
            this.loading = false
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        },
        failFun: res => {
          this.loading = false
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    // 删除签署方
    delcontract(contractId, draft) {
      //
      this.$SIF.httpPost({
        url: this.$SIF._serve.contract + '/delete/contract-join-user/list',
        data: {
          contractId: contractId
        },
        succFun: res => {
          if (res.code == 10000) {
            this.getcontract(contractId, draft)
          } else {
            this.loading = false
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        }
      })
    },
    // 添加签署方
    getcontract(contractId, draft) {
      for (var i = 0; i < this.currentItemOne.domains.length; i++) {
        this.currentItemOne.domains[i].signOrder = i + 1
      }
      this.$SIF.httpPost({
        url: this.$SIF._serve.contract + '/add/contract-join-user/list',
        data: {
          contractId: contractId,
          joinUserList: [...this.currentItemOne.domains]
        },
        succFun: res => {
          this.loading = false
          if (res.code == 10000) {
            if (draft) {
              this.$message({
                message: '已存至草稿箱',
                type: 'success'
              })
              this.loading = false
              this.back()
              return
            }
            // signature_of_documents
            this.$SIF.setLocalStorage('contractId', contractId)
            this.$router.push({
              path: '/signature_of_documents',
              query: {
                id: this.$route.params.id,
                contractId: contractId,
                serial: this.new_contact.serial,
                contractJoinUserId: res.data[0].contractJoinUserId
              }
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        },
        failFun: rer => {
          this.loading = false
        }
      })
    },
    getserial() {
      if (this.new_contact.serial == '1') {
        // this.new_contact.value2 =[]
        // this.new_contact.value2.push(this.$SIF.getLocalStorage("userInfo").userName)
        // this.currentItemOne.domains =[]
        if (this.currentItemOne.domains[0]) {
          if (this.$SIF.getLocalStorage('userInfo').loginAccount == this.currentItemOne.domains[0].value) {
            return
          } else {
            if (this.currentItemOne.domains.length > 9) {
              this.$message({
                message: '签署方最多10人,请删除之后再添加',
                type: 'warning'
              })
              this.new_contact.serial = '2'
              return
            }
            this.currentItemOne.domains.unshift({
              userId: this.$SIF.getLocalStorage('userInfo').id,
              userType: this.$SIF.getLocalStorage('userInfo').userType,
              remarkName: this.$SIF.getLocalStorage('userInfo').userName,
              activation: 1,
              authenStatus: 1,
              title: '自己'
            })
            this.currentItemOne.domains[0].value = this.$SIF.getLocalStorage('userInfo').loginAccount
            this.currentItemOne.domains[0].remarkName = this.$SIF.getLocalStorage('userInfo').userName
            this.currentItemOne.domains[0].userId = this.$SIF.getLocalStorage('userInfo').id
            this.currentItemOne.domains[0].activation = 1
            this.currentItemOne.domains[0].authenStatus = 1
            this.currentItemOne.domains[0].title = '自己'
            var domeDate = []
            for (var i = 0; i < this.currentItemOne.domains.length; i++) {
              if (!this.currentItemOne.domains[i].value) {
                domeDate.push(this.currentItemOne.domains[i])
              }
            }
            if (domeDate.length > 0) {
              this.disabled = true
            } else {
              this.disabled = false
            }
          }
        } else {
          this.currentItemOne.domains.unshift({
            userId: this.$SIF.getLocalStorage('userInfo').id,
            userType: this.$SIF.getLocalStorage('userInfo').userType,
            remarkName: this.$SIF.getLocalStorage('userInfo').userName,
            activation: 1,
            authenStatus: 1,
            title: '自己'
          })
          this.currentItemOne.domains[0].value = this.$SIF.getLocalStorage('userInfo').loginAccount
          this.currentItemOne.domains[0].remarkName = this.$SIF.getLocalStorage('userInfo').userName
          this.currentItemOne.domains[0].userId = this.$SIF.getLocalStorage('userInfo').id
          this.currentItemOne.domains[0].activation = 1
          this.currentItemOne.domains[0].authenStatus = 1
          this.currentItemOne.domains[0].title = '自己'
          var domeDate_ = []
          for (var d = 0; d < this.currentItemOne.domains.length; d++) {
            if (!this.currentItemOne.domains[d].value) {
              domeDate_.push(this.currentItemOne.domains[d])
            }
          }
          if (domeDate_.length > 0) {
            this.disabled = true
          } else {
            this.disabled = false
          }
        }
      } else {
        if (this.currentItemOne.domains[0]) {
          if (this.$SIF.getLocalStorage('userInfo').loginAccount == this.currentItemOne.domains[0].value) {
            this.currentItemOne.domains.shift()
            return
          }
        }
      }
    }
  }
}
</script>

<style scoped type="text/css">
.el_input_o {
  width: 250px;
  border: 0;
  margin-right: 22px;
}

#haofan_s {
  -webkit-appearance: none;
}

.mySeal /deep/ input::-moz-placeholder {
  color: #0c9c5b;
}

.el_input {
  width: 250px;
  background: #aaf1d1 !important;
  border: 0;
  color: #0c9c5b;
}

.el_input /deep/ .el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #0c9c5b;
}

.el_input_o /deep/ .el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #0c9c5b;
}

.el_input /deep/ .el-input__inner {
  background: #aaf1d1 !important;
  border: 0;
  color: #0c9c5b;
}

.el_input_o /deep/ .el-input__inner {
  background: #aaf1d1 !important;
  border: 0;
  color: #0c9c5b;
  padding-right: 30px;
}

.describe_test {
  width: 80%;
  margin: 0 auto;
  height: 60px;
  margin-top: 20px;
  background: rgba(49, 202, 132, 0.15);
  border-radius: 13px;
  color: #2b9063;
  padding: 10px 40px;
  font-size: 12px;
  line-height: 18px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
}

.describe_test span {
  font-weight: 600;
}

.mySeal {
  background: #ffffff;
  height: -webkit-calc(100% - 50px);
  height: -moz-calc(100% - 50px);
  height: calc(100% - 50px);
  overflow: auto;
  /*三角箭头的颜色*/
  scrollbar-arrow-color: #0fc87d;
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: #cdcdcd;
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #cdcdcd;
  /*滚动条阴影*/
  scrollbar-shadow-color: #cdcdcd;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #fff;
  /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
  scrollbar-3dlight-color: #0099dd;
  /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
  scrollbar-darkshadow-color: #0099dd;
  /*滚动条基准颜色*/
  scrollbar-base-color: #0099dd;
}

.mySeal::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}

.mySeal::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.mySeal::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.from_list {
  width: 80%;
  margin: 0 auto;
  padding: 20px 0;
}

.na_test {
  color: #717171;
}

.na_data {
  color: #22a669;
  padding: 0 15px;
}

.na_test_1 {
  color: #343434;
  padding-right: 15px;
}

.el-button_icon {
  margin-right: 15px;
  border: none;
  height: 29px;
  padding: 0;
  position: absolute;
  left: 224px;
  background: #aaf1d1;
  top: 1px;
  overflow: hidden;
}

.el-date-picker_pick {
  width: 37%;
  height: 40px;
  overflow: hidden;
  float: left;
}

.el-date-picker_pick /deep/ input {
  width: 99%;
  margin: 0 auto;
}

.buyyon_icon {
  margin-left: 15px;
  border: none;
  height: 30px;
  padding: 0;
  font-size: 18px;
  color: #0c9c5b;
}

.el-button_icon /deep/ i {
  font-size: 23px;
  color: #0c9c5b;
}

.el-button_icon:hover {
  color: #aaf1d1;
  background-color: #aaf1d1;
  border: none;
}

.docDetails {
  width: 100%;
  height: 100%;
}

.tun_m {
  margin: 0;
  line-height: 40px;
}

.detail_msg {
  padding: 10px 27px 0px 27px;
  overflow: hidden;
  background: rgba(245, 247, 246, 1);
  border-radius: 3px 3px 0px 0px;
  border: 1px solid rgba(233, 232, 232, 1);
}

.detail_msg span {
  margin-left: 15px;
  font-size: 12px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(113, 113, 113, 1);
  line-height: 25px;
}

.detail_msg .bc_butn {
  width: 57px;
  height: 24px;
  background: rgba(49, 202, 132, 1);
  border-radius: 3px;
  color: #fff;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 10px;
  float: left;
}

.el-radio.is-bordered.is-checked {
  background: #f3fff9;
}

.el_radio {
  padding: 3px 10px;
  height: auto;
  width: 248px;
  margin-right: 15px;
}

.el_radio /deep/ .el-radio__input {
  margin-top: 12px;
  float: right;
}

.el_radio /deep/ .el-radio__label {
  line-height: 20px;
  display: inline-block;
  float: left;
}

.el_radio_one /deep/ .el-radio__label {
  line-height: 38px;
  display: inline-block;
  float: left;
}

.el_radio_one /deep/ .el-radio__input {
  float: right;
  margin-top: 12px;
}

.guang_b >>> .el-input {
  width: 260%;
}

.fu_test {
  font-size: 12px;
  color: #b5b5b5;
}

.from_div {
  width: 100%;
  text-align: right;
  padding-right: 30px;
  overflow: hidden;
  padding-bottom: 15px;
}

.Safety {
  color: #1c965e;
  margin-right: 10px;
}

.Danger {
  color: #ec7042;
  margin-right: 10px;
}

.docDetails >>> .el-loading-spinner {
  width: 200px;
  height: 200px;
  background: url(~@/assets/img/loding.gif) no-repeat;
  background-size: 50% 100%;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  animation: raise 4s ease-in-out infinite;
  top: 35%;
  left: 48%;
  position: relative;
}

.docDetails >>> .el-loading-spinner .circular {
  width: 42px;
  height: 42px;
  animation: loading-rotate 2s linear infinite;
  display: none;
}

.docDetails >>> .el-loading-mask {
  background-color: rgba(0, 0, 0, 0.5);
}

.from_button {
  width: 110px;
  height: 33px;
  padding: 0;
  line-height: 33px;
}

.from_button_one {
  border: 1px solid #19bc73;
  color: #19bc73;
  background: #ffffff;
}
</style>
<style scoped type="scss">
.el_radio {
  .el-radio__input {
    display: none;
  }

  &.is-checked {
    position: relative;

    &:after {
      content: '';
      display: block;
      height: 20px;
      width: 20px;
      /*background-image: url(~@/assets/img/fb.png);*/
      /*background-size: 100%;*/
      background: #0b804c;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>